export default {
    attribute: {
        url: '',
        fit: 'fill',
        preview: false,
        autoRotate: false,
        rotateDuration: 2,
        bgColor: 'rgba(0,0,0,0)'
    },
    interaction: {
        intType: 'none'
    }
}